export default __webpack_public_path__ + "static/media/checkoutPedicure.11ffe0d9.png";